import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCkgaUmuop30_9Po0eAxHs12jh9HvHZbuo",
  authDomain: "tripdatasite.firebaseapp.com",
  projectId: "tripdatasite",
  storageBucket: "tripdatasite.firebasestorage.app",
  messagingSenderId: "627176086444",
  appId: "1:627176086444:web:98aa609cdfeaac7fe9f809",
  measurementId: "G-6J5RW1BMLZ"
};

const app      = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const fbAuth   = getAuth(app);
const provider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  const result     = await signInWithPopup(fbAuth, provider);
  const credential = GoogleAuthProvider.credentialFromResult(result);
  return credential.idToken;
}

export { app, analytics };